import { KEYS } from '@/services/menu/types';
import { SOURCES } from '@/types/enums/common';
import { KIOSK_PREFIX } from '@/utils/constants/kiosk';
import isSourceValid from '@/utils/functions/is-source-valid';

export const getKioskUrl = (url: string): string => {
	const tempData = JSON.parse(
		sessionStorage.getItem(KEYS.MENU_TEMP_DATA) || '{}'
	);

	const isTablet =
		tempData.source && isSourceValid(tempData.source, SOURCES.TABLET);

	if (isTablet) {
		const cleanUrl = url.startsWith('/') ? url.slice(1) : url;
		return `${KIOSK_PREFIX}/${cleanUrl}`;
	}

	return url;
};
